/** Header SignIn / Cart links that also attach their own onClick navigation. */
const HEADER_SSO_MODULES = new Set(["myaccount", "cart"]);

const getSsoModuleFromHref = (href: string): string | null => {
  const queryStart = href.indexOf("?");
  if (queryStart === -1) {
    return null;
  }

  const hashIndex = href.indexOf("#", queryStart + 1);
  const query =
    hashIndex === -1 ? href.slice(queryStart + 1) : href.slice(queryStart + 1, hashIndex);

  return new URLSearchParams(query).get("sso-module");
};

/**
 * Header Sign In and Cart anchors register their own onClick handlers that navigate
 * via window.location.href. ClickHandler should stop propagation for these links so
 * only the SSO redirect runs (avoids opening two sign-in / cart tabs).
 */
export const shouldStopPropagationForHeaderSsoLink = (href: string): boolean => {
  if (!href) {
    return false;
  }

  try {
    const ssoModule = getSsoModuleFromHref(href);
    return ssoModule !== null && HEADER_SSO_MODULES.has(ssoModule);
  } catch {
    return false;
  }
};
